import { QuillEditor } from "@pathwright/blocks/src/shared"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { TOOLBAR_CONFIG_TYPES } from "@pathwright/ui/src/components/quill/toolbar/QuillToolbar"
import { Col, Row } from "./ui"

const TextEdit = (props) => {
  const { layout, data } = props

  const handleChange = (key) => (value) => {
    props.onChange({ [key]: value })
  }

  switch (layout) {
    case "two-column":
      return (
        <Content.Container>
          <Row>
            <Col>
              <QuillEditor
                html={data.html}
                onChange={handleChange("html")}
                toolbar={TOOLBAR_CONFIG_TYPES.ADVANCED}
                controlled
              />
            </Col>
            <Col>
              <QuillEditor
                html={data.aside}
                onChange={handleChange("aside")}
                toolbar={TOOLBAR_CONFIG_TYPES.ADVANCED}
                controlled
              />
            </Col>
          </Row>
        </Content.Container>
      )

    default:
      return (
        <Content.Container>
          <QuillEditor
            html={data.html}
            onChange={handleChange("html")}
            toolbar={TOOLBAR_CONFIG_TYPES.ADVANCED}
            controlled
          />
        </Content.Container>
      )
  }
}

export default TextEdit
